import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { FontVariant } from '../../utils/types/typography';
import { popupContentMixin } from './popup-content.mixin';
var baseClassName = 'PopupContent';
var LabelWrapper = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'LabelWrapper')
}).withConfig({
  componentId: "sc-njbmnt-0"
})(function (_ref) {
  var palette = _ref.theme.palette;
  return css(["display:flex;flex-grow:1;margin-left:44px;margin-right:28px;padding:16px;padding-right:0;overflow:hidden;background:", ";"], palette[PColor.ButtonPrimaryText]);
});
var Label = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'Label')
}).withConfig({
  componentId: "sc-njbmnt-1"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    font = _ref2$theme.typography.font;
  return css(["max-width:100%;overflow:hidden;text-overflow:ellipsis;color:", ";", ""], palette[PColor.TextPrimary], font[FontVariant.TextSmallUp]);
});
var PopupContent = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'PopupContent')
}).withConfig({
  componentId: "sc-njbmnt-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["position:relative;display:flex;align-items:center;width:360px;border-radius:4px;box-shadow:0px 2px 6px ", ";"], theme.palette[PColor.LargeShadow]);
});
var CloseWrapper = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'PopupContent')
}).withConfig({
  componentId: "sc-njbmnt-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["position:absolute;top:0;right:0;display:flex;justify-content:center;align-items:flex-start;box-sizing:border-box;padding:2px;height:fit-content;cursor:pointer;background:", ";border-radius:0 4px 4px 0;height:100%;"], theme.palette[PColor.BackgroundStateless]);
});
var PopupStatus = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'PopupStatus')
}).withConfig({
  componentId: "sc-njbmnt-4"
})(function (_ref5) {
  var _ref5$status = _ref5.status,
    status = _ref5$status === void 0 ? 'success' : _ref5$status;
  return css(["position:absolute;display:flex;left:0;z-index:1;height:100%;min-width:44px;align-items:center;justify-content:center;box-sizing:border-box;border-radius:4px 0 0 4px;", ""], popupContentMixin[status]);
});
var Styled = applyDisplayNames({
  PopupContent: PopupContent,
  PopupStatus: PopupStatus,
  LabelWrapper: LabelWrapper,
  CloseWrapper: CloseWrapper,
  Label: Label
});
export default Styled;